// removed by extract-text-webpack-plugin
module.exports = {"studio":"_1iPXKX5AFisV54mNcutTUc","studio__description":"_4Yc8cGP_3ZhYwEzenUgtx","studio__description__counts":"_3PNzRqw6QKUyerVqliWnZT","studio__description__contents":"_22QfKcdQsY1iNXmuebP4_V","studio__main":"PIytbUiJFaJna3Z9BbRiG","studio__main__contents":"_14svhu2icjPJNNCQQPXHEK","studio__main__contents__studio-download":"Ks7ip7BtwVd0PI674hdbz","studio__main__contents__studioDownload":"Ks7ip7BtwVd0PI674hdbz"};


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/Studio/style.scss
// module id = 529
// module chunks = 0